<template>
  <div id="app" class="app_css" ref="app">  
    <router-view :configObj="configObj"/>

    <el-dialog
      title="用户隐私收集说明"
      :visible.sync="showPrivacyDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
    >
      <div style="white-space: pre-line;" class="tip_text_ys">为了向您提供更加便捷、高效的服务，本系统部分模块需要采集您的信息数据，并授权学校相关信息系统获得您所填写或留存在学校的身份信息（如姓名、照片、身份证号、学工号等信息）。这些信息将仅用于帮助您在学校不同的信息系统中更快捷地使用相应的服务。
      </div>
      <div style="white-space: pre-line;"  class="tip_text_ys">您同意本协议并开始使用我们的服务后，我们将严格按照《中华人民共和国个人信息保护法》、《{{ configObj.schoolName }}个人信息保护管理办法》及相关法律法规的要求，使用与保护您的个人信息。感谢您的信任与支持。</div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          type="primary" 
          :disabled="countdown > 0 || submitting"
          @click="handleClick"
        >
          我已知晓
          <span v-if="countdown > 0">（{{ countdown }}s）</span>
        </el-button>
      </span>
  </el-dialog>
  </div>
</template>

<script>
import api from "@/fetch/api";
import to from "await-to-js";
export default {
  name: 'App',
  data(){
    return {
      configObj: {},
      showPrivacyDialog: false,
      countdown: 0,
      countdownTimer: null,
      submitting: false,
    }
  },
  created(){
    this.configView();
    this.checkPrivacyDialog();
    console.log("app进来了")
  },
  methods:{
    // 检查是否需要弹出隐私弹窗
    checkPrivacyDialog() {
      // 本地记忆key
      const PRIVACY_KEY = "privacyDialogClosed";
      // 读取本地存储
      const closed = localStorage.getItem(PRIVACY_KEY);
      // firstLogin 从 vuex 获取
      const firstLogin = this.$store.state.userInfo && this.$store.state.userInfo.firstLogin;
      if (firstLogin === 1 && !closed) {
        this.showPrivacyDialog = true;
        this.startCountdown();
      } else {
        this.showPrivacyDialog = false;
      }
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 5;
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    // 点击“我已知晓” agreePrivacy
    async handleClick(){
      if (this.countdown > 0 || this.submitting) return;
      this.submitting = true;
      // 调用接口通知服务端
      const [err, result] = await to(api.agreePrivacy());
      if (err) Promise.reject(err);
      if (result.code === 200) {
        // 关闭弹窗
        this.showPrivacyDialog = false;
      }
    },
    // 获取详情
    async configView() {
      const [err, result] = await to(api.configView());
      if (err) Promise.reject(err);
      if (result.code === 200) {
        this.configObj = result.data;
        let _url = ""
        if(result.data.logo){
          _url = this.$imgUrl+result.data.logo;
        }
        this.changeFavicon(_url);
        this.changeTitle(`${result.data.schoolName} - 继续教育综合平台`)
      }
    },
    changeFavicon(iconUrl) {
      let link = document.querySelector('#logo_link');
      if (link) {
        link.href = iconUrl;
      } else {
        link = document.createElement('link');
        link.id = 'logo_link';
        link.rel = 'icon';
        link.href = iconUrl;
        document.head.appendChild(link);
      }
    },
    
    changeTitle(title) {
      document.title = title;
    },
    getInitData(){
      let _token = this.$store.state.token;
      if(_token){
          this.$store.dispatch("getEnumsList");
      }
    },
    toTop(){
     
    },
  },
  computed:{
    firstLogin(){
      return this.$store.state.userInfo.firstLogin;
    }
  },
  watch: {
    // 监听 firstLogin 变化，动态检查弹窗
    firstLogin(newVal) {
      this.checkPrivacyDialog();
    }
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },
  components:{
  }
}
</script>

<style lang='scss' scope>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  min-width: 1400px;
  .header_wrap{
  background: linear-gradient(to top, rgb(225, 64, 1), rgb(245, 110, 47) 70px);
  color: #fff;
  }
}

 
        /*重置滚动条整体样式*/
        .app_css::-webkit-scrollbar {
          /*滚动条整体样式*/

          width: 8px;
          /*高宽分别对应横竖滚动条的尺寸*/

          height: 8px;

        }

        .app_css::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/

          border-radius: 10px;

          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);

          background: #5C5B5B;

        }

        .app_css::-webkit-scrollbar-track {
          /*滚动条里面轨道*/

          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);

          border-radius: 10px;

          background: #000;

        }

.tip_text_ys{
  line-height: 28px;
  margin-bottom: 5px;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue